import React, { memo } from 'react';
import {
  IconBannersWarning,
  LinkText,
  Text,
  VStack,
} from '@adc/parallax-component-library';
import { useNavigate } from 'react-router';
import i18n from '../../utilities/i18n';
import { ROUTES } from '../../constants';

function NotFound() {
  const navigate = useNavigate();

  return (
    <VStack alignItems="center" justifyContent="center" flex={1} gap="$2">
      <VStack alignItems="center">
        <IconBannersWarning size="XL" accentColor="$support.warning.default" />
        <Text type="$h2.strong">{i18n.t('PageNotFound.title')}</Text>
        <Text type="$bodyBase.default" textAlign="center">
          {i18n.t('PageNotFound.description')}
        </Text>
      </VStack>
      <LinkText
        onPress={() => navigate(ROUTES.ROOT)}
        href=""
        type="$bodyBase.default"
      >
        {i18n.t('PageNotFound.goHome')}
      </LinkText>
    </VStack>
  );
}

export default memo(NotFound);
